import { Pipe, PipeTransform } from '@angular/core';
import { I18nService } from '../i18n.service';

@Pipe({
  name: 'i18n'
})
export class I18nPipe implements PipeTransform {

  constructor(private i18nSvc: I18nService) {
  }

  transform(value: string | undefined | null, par?: any): string {
    if (value !== undefined) {
      if (par !== undefined) {
        return this.i18nSvc.translate(value!, par.toString());
      } else {
        return this.i18nSvc.translate(value!);
      }
    } else return '';
  }

}
